import { Injectable } from "@angular/core";
import { ServicesService } from "../users/services.service";
import { CoreComponent } from "../core/core.component";
import { DisbursementExclusions } from "./application/disbursement.exclusions";
import { HttpClient } from "@angular/common/http";
import { Router } from "@angular/router";
import { CookieService } from "ngx-cookie-service";
import { ConfigServices } from "../core/config";
import { ApplicationsService } from "./applications.service";
import { Application } from "./application/application";

declare var moment: any;

@Injectable({
  providedIn: 'root'
})
export class DisbursementExclusionsService extends ServicesService {
    
      constructor(public http: HttpClient, public configService: ConfigServices, public applicationsService: ApplicationsService, public cookieService: CookieService, private router: Router) {
        super('assisted', http, configService);
      }

    getDisbursementExclusions(application: Application) {
        const url = this.configService.getApi() + 'disbursement-exclusions/' + application?.id;
        return this.http.get(url, {withCredentials: true});
    }
}